import { parseDefiniteQuotationDTO, QuotationDTO } from 'components/ordering/quotation/api/dtos/quotation-dto.js'
import { StatusCodeToError } from 'components/ordering/quotation/api/dtos/error.js'
import { QuotationRequest } from 'components/ordering/quotation/api/quotation-request.js'


const EXPECTED_ERRORS = [400, 404] as const
type ExpectedErrors = StatusCodeToError<typeof EXPECTED_ERRORS[number]>

type AddQuotationToBasketPayload = {
  quotationId: number
}

export class AddQuotationToBasket extends QuotationRequest<QuotationDTO, ExpectedErrors> {
  path: string
  override init: RequestInit
  override expectedErrors = EXPECTED_ERRORS

  constructor({ quotationId }: AddQuotationToBasketPayload) {
    super()

    this.path = `quotation/${quotationId}/add_to_basket/`
    this.init = {
      method: 'POST',
    }
  }

  override parseResponse = parseDefiniteQuotationDTO
}
